(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExhibitorByExpoReportController', PhysicalFairExhibitorByExpoReportController);

    PhysicalFairExhibitorByExpoReportController.$inject = ['$uibModal', 'ExpoService', 'CountriesNewService', 'CitiesByExpoService', 'PhysicalFairService', 'SellerService', 'AdmService', 'API_BASE', '$timeout'];


    function PhysicalFairExhibitorByExpoReportController($uibModal, ExpoService, CountriesNewService, CitiesByExpoService, PhysicalFairService, SellerService, AdmService, API_BASE, $timeout) {
        var vm = this;

        vm.expo;
        vm.API_BASE             = API_BASE;
        vm.numberOfResult       = 0;
        vm.expoSelected;
        vm.citySelected;
        vm.city;
        vm.country               = '';
        vm.data                  = [];
        vm.countrySelected       = '';
        vm.flag                  = '';

        vm.citySelectedCSV       = '';
        vm.countrySelectedCSV    = '';
        vm.expoSelectedCSV       = '';
        vm.sellerSelected        = '';

        vm.selectExpo            = selectExpo;
        vm.selectCountries       = selectCountries;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.selectSellers         = selectSellers;
        vm.getByFilter           = getByFilter;
        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.downloadCSV           = downloadCSV;
        vm.checkLocation         = checkLocation;


        function activate() {
            vm.selectExpo();
            vm.selectCountries();
            vm.selectSellers();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function selectCountries () {
            CountriesNewService.getCountries().then(function(response){
                vm.country = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            vm.query = {};
            vm.query['expos_ids']  = JSON.stringify(vm.expoSelected);
            CitiesByExpoService.getCitiesByExposIds(vm.query).then(function(response){
                vm.city = response.data;
            }).catch(function(err) {

            });
        }

        function selectSellers () {
            AdmService.getSellers().then(function(response){
                vm.sellers = response.data;
            }).catch(function(err) {

            });
            // SellerService.getAll().then(function(response){
            //     vm.sellers = response.data;
            // }).catch(function(err) {

            // });
        }

        function getByFilter() {
            vm.query = {};
            if(typeof vm.citySelected !== 'undefined' && vm.citySelected !== "") {
                vm.query['city_id']   = JSON.stringify(vm.citySelected);
            }
            if(typeof vm.countrySelected !== 'undefined' && vm.countrySelected !== "") {
                vm.query['country_id']   = JSON.stringify(vm.countrySelected);
            }
            if(typeof vm.expoSelected !== 'undefined' && vm.expoSelected !== "") {
                vm.query['expo_id']   = JSON.stringify(vm.expoSelected);
            }
            if(typeof vm.sellerSelected !== 'undefined' && vm.expoSelected !== "") {
                vm.query['seller_id']   = JSON.stringify(vm.sellerSelected);
            }
            vm.query['page']            = vm.page;
            PhysicalFairService.getByFilterExhibitorsByExpo(vm.query).then(function(response){
                vm.expoCities = response.data.cities;
                vm.data = response.data.exhibitors.exhibitors;
                vm.numberOfResult = Object.keys(response.data.exhibitors.exhibitors).length;
                vm.flag = true;
                vm.totalItems = response.data.exhibitors.total;
                vm.to         = response.data.exhibitors.to;
                vm.setPage(response.data.exhibitors.current_page);
                vm.itemsPerPage = response.data.exhibitors.per_page;
            }).catch(function(err) {

            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }
        function downloadCSV () {
            vm.query = {};
            if(typeof vm.citySelected !== 'undefined' && vm.citySelected !== "") {
                vm.query['city_id']   = JSON.stringify(vm.citySelected);
            }
            if(typeof vm.countrySelected !== 'undefined' && vm.countrySelected !== "") {
                vm.query['country_id']   = JSON.stringify(vm.countrySelected);
            }
            if(typeof vm.expoSelected !== 'undefined' && vm.expoSelected !== "") {
                vm.query['expo_id']   = JSON.stringify(vm.expoSelected);
            }


            PhysicalFairService.downloadReportExhibitorByExpoCSV(vm.query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'report_exhibitors_by_expo.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }

        activate();

    }

    function checkLocation(locations, location_id)
    {
        console.log(locations);
        console.log(location_id);
        console.log(locations.location_id);
    }

})();